import React from "react";
import { Button, DatePicker, Space } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import dayjsTZ from "../../../../utils/dayjs";
import { monthBoundsInTz } from "../../../../utils/timezone/dayBounds";
import { getCompanyTimezone } from "../../../../utils/timezone/teamTimezone";

/**
 * Timecard-style month chips (prev / current / next) + month picker + step nav.
 */
const PlanerMonthFilter = ({ month, onMonthChange }) => {
  const current = dayjsTZ(month).startOf("month");

  const chips = [-1, 0, 1].map((offset) =>
    dayjsTZ().startOf("month").add(offset, "month")
  );

  const toCompanyMonth = (val) => {
    const { startMs } = monthBoundsInTz(getCompanyTimezone(), val);
    return dayjsTZ(startMs);
  };

  return (
    <div className="planer-month-filter">
      <Space wrap size={8} align="center">
        <Button
          type="text"
          icon={<LeftOutlined />}
          onClick={() => onMonthChange(current.subtract(1, "month"))}
          aria-label="Muaji i kaluar"
        />
        <div className="planer-month-chips">
          {chips.map((m) => {
            const active = m.isSame(current, "month");
            return (
              <button
                key={m.format("YYYY-MM")}
                type="button"
                className={active ? "active-filter" : "inactive-filter"}
                onClick={() => onMonthChange(m)}
              >
                {m.format("MMMM YYYY")}
              </button>
            );
          })}
        </div>
        <Button
          type="text"
          icon={<RightOutlined />}
          onClick={() => onMonthChange(current.add(1, "month"))}
          aria-label="Muaji i ardhshëm"
        />
        <DatePicker
          picker="month"
          allowClear={false}
          value={current}
          format="MMMM YYYY"
          onChange={(val) => val && onMonthChange(toCompanyMonth(val))}
        />
      </Space>
    </div>
  );
};

export default PlanerMonthFilter;
